window.app = window.app || {};

window.app.featuredCollection = {
  el: {
    list: document.querySelector('.mt-featured-collection__list'),
    carousel: document.querySelector('.mt-featured-collection__list .swiper')
  },

  init: function() {
    const _this = this;
    if (!_this.el.carousel) return;
    
    const slidesCount = Number(_this.el.list.dataset.slides);
    let sliderConfig = {
      md: { slidesPerView: Math.min(slidesCount, 3) },
      lg: { slidesPerView: slidesCount }
    };
    if (slidesCount > 4) {
      sliderConfig.lg = { 
        slidesPerView: 3, 
        grid: { fill: 'row', rows: 2 }
      };
    }
    let sliderOptions = {
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: Number(_this.el.list.dataset.slides) > 2 ? 2 : Number(_this.el.list.dataset.slides)
        },
        1000: sliderConfig.md,
        1200: sliderConfig.lg
      }
    };

    // Featured on Article page
    if (_this.el.carousel.closest('.template-article')) {
      sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: 24,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 48
          }
        }
      }

      // Additional events
      const featuredProducts = _this.el.list.querySelectorAll('.mt-product-item');
      featuredProducts.forEach(product => {
        const title = product.querySelector('.mt-product-item__title');
        const links = product.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', () => window.app.dl.blogRelatedProductClick(title.innerText));
        });
      });
    }

    _this.slider = new Swiper(_this.el.carousel, sliderOptions);
  }
}
window.app.featuredCollection.init();